var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCliente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.778,
    height: 31.422,
    viewBox: "0 0 32.778 31.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confirm-purchase-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_39_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2270",
    "data-name": "Raggruppa 2270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3517",
    "data-name": "Tracciato 3517",
    d: "M45.715,29.585l-.026-.418c-.214.019-.427.037-.639.037-1.4,0-3.11-1.59-4.175-2.372l-4.915-4.5a4.236,4.236,0,0,1-.489-6.755,3.793,3.793,0,0,1,2.777-1.082,4.955,4.955,0,0,1,3.332,1.082l2.2,1.515,1.032-1.363-.39-5.972a1.973,1.973,0,0,0-2.1-1.647H40.335V5.482C40.335,2.459,37.365,0,33.716,0S27.1,2.459,27.1,5.481V8.108h-2a1.973,1.973,0,0,0-2.1,1.647l-1.294,19.83a1.583,1.583,0,0,0,.574,1.292,2.327,2.327,0,0,0,1.526.544h19.8a2.333,2.333,0,0,0,1.527-.544A1.583,1.583,0,0,0,45.715,29.585ZM30.953,5.481a2.563,2.563,0,0,1,2.764-2.29,2.566,2.566,0,0,1,2.766,2.291V8.108h-5.53Z",
    transform: "translate(-21.708)",
    fill: "#5f75d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3518",
    "data-name": "Tracciato 3518",
    d: "M226.941,172.418a2.129,2.129,0,0,0-2.933.671l-5.773,9.2-3.332-2.954a2.127,2.127,0,0,0-2.822,3.184l5.21,4.619a2.128,2.128,0,0,0,1.411.536,2.089,2.089,0,0,0,.3-.022,2.125,2.125,0,0,0,1.5-.975l7.109-11.329A2.126,2.126,0,0,0,226.941,172.418Z",
    transform: "translate(-195.16 -161.13)",
    fill: "#5f75d1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliente);
export default __webpack_public_path__ + "static/media/cliente.474ac8049ec287602b6c56af8624ae3c.svg";
export { ForwardRef as ReactComponent };